import Machine from '../../types/api/machine'

type GroupedMachines = Record<string, Machine[]>
/**
 * Итерируется по массиву machines.
 * Берёт machine.machine_brand?.name, если нет бренда — подставляет 'Unknown'.
 * Добавляет машину в соответствующую группу.
 * @param machines
 * @returns
 */
export function groupMachinesByBrand(machines: Machine[]): GroupedMachines {
    return machines.reduce((acc: GroupedMachines, machine) => {
        const brandName = machine.machine_brand?.name || 'Unknown'
        if (!acc[brandName]) {
            acc[brandName] = []
        }
        acc[brandName].push(machine)
        return acc
    }, {})
}
